module.exports = __webpack_public_path__ + "static/media/wizard-finish.3c12e8fd.png";